<template>
  <div>
    <div>
      <b-img
        v-if="dataItem[iKey].image"
        :src="imageUrl + '/media/product_items/' + dataItem[iKey].image"
        thumbnail
        center
      />
      <div
        class="text-center"
        :class="dataItem[iKey].image ? 'mt-2':'mt-5'"
      >
        <b-alert
          v-if="!dataItem[iKey].image"
          show
          variant="info"
          class="ml-1 mr-1"
        >
          <div class="text-center alert-body">
            <feather-icon icon="InfoIcon" />
            Detay görseli eklenmemiş.
          </div>
        </b-alert>
        <b-button
          variant="primary"
          @click="setModal('product_items')"
        >
          <FeatherIcon icon="UploadIcon" />
          Görsel Yükle
        </b-button>
      </div>
    </div>
    <cropper-image
      v-if="cropperSettings.type"
      :modal-status="cropperSettings.modalStatus"
      :close-modal="closeModal"
      :file-name="cropperSettings.fileName"
      :folder="cropperSettings.folder"
      :ratio="cropperSettings.ratio"
      :width-size="cropperSettings.widthSize"
      component="product_items"
      :params="cropperSettings.type"
      :item-id="dataItem[iKey].id"
      @uploadImage="setUploadImage"
    />
  </div>
</template>
<script>
import { BImg, BButton, BAlert } from 'bootstrap-vue'
import CropperImage from '@/layouts/components/common/CropperImage.vue'
import { required } from '@core/utils/validations/validations'

export default {
  name: 'ProductItemsImageCard',
  components: {
    BAlert,
    BImg,
    BButton,
    CropperImage,
  },
  props: {
    iKey: {
      type: Number,
      required: true,
    },
  },
  data() {
    return {
      cropperSettings: {
        modalStatus: false,
        fileName: null,
        folder: null,
        ratio: null,
        widthSize: null,
        type: null,
      },
      required,
      imageUrl: this.$store.state.app.baseURL,
    }
  },
  computed: {
    dataItem() {
      return this.$store.getters['productItems/dataList']
    },
  },
  methods: {
    setModal(type) {
      if (type === 'product_items') {
        this.cropperSettings = {
          modalStatus: true,
          fileName: 'product_items-image.jpg',
          folder: 'product_items',
          ratio: 1,
          widthSize: 1200,
          type: 'product_items',
        }
      }
    },
    closeModal() {
      this.cropperSettings = {
        modalStatus: false,
        fileName: null,
        folder: null,
        ratio: null,
        type: null,
      }
    },
    setUploadImage(item) {
      this.dataItem[this.iKey].image = item.filename
      this.dataItem[this.iKey].thumb = item.thumb
      this.dataItem[this.iKey].image_webp = item.filename_webp
      this.dataItem[this.iKey].thumb_webp = item.thumb_webp
      this.dataItem[this.iKey].mediaData = item
      this.cropperSettings.modalStatus = false
    },
  },
}
</script>
